import { Box, Checkbox, Flex, Select, Table } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { Rating } from 'shared/components/rating';
import { useJobApplicants } from '../job-applicants-provider';
import { Candidate } from '../types';
import { AddCommentOnCandidate } from './add-comment-on-candidate';
import { JobApplicantCoverLetter } from './job-applicant-cover-letter';
import { JobApplicatCvs } from './job-applicant-cvs';

function JobApplcantRowView({ candidate }: { candidate: Candidate }) {
   const { slug } = useParams();
   const jobApplicants = useJobApplicants();
   const isLoadingStatus = jobApplicants.statusChangeState.status === 'pending';
   const isSelected = !!jobApplicants.selectedCandidates.find(c=>c.user_id === candidate.user_id);
   
   return (
      <>
         <Table.Row key={candidate.user_id} align="end">
            <Table.Cell width="80px" justify="center" align="center">
               <Checkbox
                  color="blue"
                  size="2"
                  highContrast
                  checked={isSelected}
                  onCheckedChange={() => {
                     jobApplicants.onToggleCandidate(candidate);
                  }}
               />
            </Table.Cell>

            <Table.Cell width="220px">{candidate.name}</Table.Cell>

            <Table.Cell width="200px">{candidate.created}</Table.Cell>

            <Table.Cell>
               <Rating
                  initialRating={candidate.rating}
                  onRatingChange={(val) => {
                     if (slug) {
                        jobApplicants.updateRating({
                           id: candidate.job_apply_id,
                           val: val,
                        });
                     }
                  }}
               />
            </Table.Cell>

            <Table.Cell>
               <Select.Root
                  value={candidate.apply_status}
                  disabled={isLoadingStatus}
                  onValueChange={(status) => {
                     if (slug) {
                        jobApplicants.onStatusChange({
                           candidateId: candidate.job_apply_id,
                           userId: candidate.user_id,
                           status,
                           slug: slug,
                        });
                     }
                  }}
               >
                  <Select.Trigger style={{ width: '160px', minWidth: '160px' }}></Select.Trigger>
                  <Select.Content position="popper">
                     {jobApplicants.statusOptions.map((opt) => (
                        <Select.Item
                           disabled={opt.value === 'reviewed' || opt.value === 'new'}
                           key={opt.value}
                           value={opt.value}
                        >
                           {opt.viewValue}
                        </Select.Item>
                     ))}
                  </Select.Content>
               </Select.Root>
            </Table.Cell>

            <Table.Cell className="action-cell" width="200px">
               <JobApplicatCvs candidate={candidate} />
            </Table.Cell>
         </Table.Row>

         <Table.Row style={{ border: 0 }}>
            <Table.Cell colSpan={7} style={{ borderBottom: '1px solid var(--gray-3)' }}>
               <Flex pl="3" gap="2" direction="column">
                  <JobApplicantCoverLetter candidate={candidate} />
                  <AddCommentOnCandidate candidate={candidate} />
               </Flex>
            </Table.Cell>
         </Table.Row>
      </>
   );
}

export const JobApplcantRow = observer(JobApplcantRowView);
